
import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const PopoverContent = ({ content, position, onClose }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return createPortal(
    <div
      ref={popoverRef}
      style={{
        position: "absolute",
        left: `${position.left}px`,
        top: `${position.top}px`,
        zIndex: 1000,
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: "4px",
        padding: "6px 10px",
        fontSize: "12px",
        whiteSpace: "nowrap",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        transform: "translateX(-50%)",
      }}
    >
      {content}
      {/* Arrow */}
      <div
        style={{
          position: "absolute",
          bottom: "-5px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "5px solid #333",
        }}
      />
    </div>,
    document.body
  );
};


const ViewRFQButton = (props) => {
  const context = props.context.componentParent;
  const indent = props.data.indent || {};

  const [showPopover, setShowPopover] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });

  const handleClick = (type, e) => {
    e.stopPropagation();
    switch (type) {
      case "material":
        context.onClickshowbiddata(props);
        break;
      case "attachment":
        context.onClickViewPOD(props);
        break;
      case "comment":
        context.onClickComments(props);
        break;
      case "bidding":
        context.onClickviewRFQ(props);
        break;
      case "notification":
        context.fetchNotificationsData(props);
        break;
      case "cancelindent":
        context.cancelindent(indent);
        break;
      case "commentsall":
        context.onClickallcomments(props);
        break;
      default:
        break;
    }
  };

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      left: rect.left + rect.width / 2,
      top: rect.top - 35 + window.scrollY, // above button
    });
    setShowPopover(true);
  };

  const handleMouseLeave = () => {
    setShowPopover(false);
  };

  return (
<div className="flex-gap-relative">
      {indent.is_draft === 1 ? null : (
        <>
          <button
            onClick={(e) => handleClick("bidding", e)}
            className="custom-btn label label-success"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <img
              src={require("../../assets/images/eye (1).svg")}
              style={{
                cursor: "pointer",
                position: "relative",
                height: "12px",
              }}
              alt="RFQ"
            />
          </button>
          {showPopover && (
            <PopoverContent
              content="View Indent"
              position={position}
              onClose={() => setShowPopover(false)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ViewRFQButton;



